import React from "react";
import { apiUploadImage } from "./apiClient";
import { getApiBaseUrl } from "../config/appSettings";

export function ImageUploadField({ label, value, onChange, accept = "image/*", labelClassName }) {
  const labelCls =
    labelClassName ?? "mb-1 block text-sm font-medium text-slate-700";
  const [uploading, setUploading] = React.useState(false);
  const [error, setError] = React.useState("");

  const onFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError("");
    const res = await apiUploadImage("/api/Uploads/image", file);
    if (!res.ok) {
      setError(res.error ?? "Upload failed.");
    } else {
      const uploadedPath = String(res.data?.path ?? res.data?.Path ?? "").trim();
      if (!uploadedPath) {
        setError("Upload succeeded but no image path was returned.");
      } else {
        onChange(uploadedPath);
      }
    }
    setUploading(false);
  };

  const canPreview = typeof value === "string" && value.trim().length > 0;
  const baseUrl = getApiBaseUrl();
  const previewSrc =
    canPreview && (value.startsWith("http://") || value.startsWith("https://") || value.startsWith("data:"))
      ? value
      : canPreview
        ? `${baseUrl}${value.startsWith("/") ? value : `/${value}`}`
        : "";

  return (
    <label className="block min-w-0">
      <span className={labelCls}>{label}</span>
      <input
        type="file"
        accept={accept}
        onChange={onFileChange}
        className="block w-full text-sm text-slate-600"
      />
      {uploading && <span className="text-xs text-slate-500">Uploading…</span>}
      {error && <span className="text-xs text-red-600 block">{error}</span>}
      {canPreview && (
        <div className="mt-2 flex items-start gap-2">
          <img src={previewSrc} alt="" className="h-20 rounded-lg border object-cover" />
          <button
            type="button"
            onClick={() => onChange("")}
            className="text-xs text-slate-500 hover:text-red-600"
          >
            Remove
          </button>
        </div>
      )}
    </label>
  );
}
